module.exports = __webpack_public_path__ + "assets/13e7f5f3cf8ea3eecdd0b0339487c221.png";